<template>
  <b-form :submit="submitResetPassword" class="forgot" hide-action-buttons>
    <b-label>
      <span class="text">Номер телефону</span>
    </b-label>
    <b-input-phone
      v-model="phone"
      :error-messages="getErrorMessages(resetV$.phone)"
      :readonly="isSendSms"
      class="mb-3"
      hide-details
      @keyup.enter="submitResetPassword()">
    </b-input-phone>
    <div v-if="isSendSms">
      <b-input-password
        v-model="resetData.password"
        :error-messages="getErrorMessages(resetV$.resetData.password)"
        :submit="submitResetPassword"
        class="mb-4"
        hide-details
        label="Пароль"
        @blur="resetV$.resetData.password.$touch()"></b-input-password>
      <b-input
        v-model="resetData.passwordRepeat"
        :error-messages="getErrorMessages(resetV$.resetData.passwordRepeat)"
        :submit="submitResetPassword"
        class="mb-4"
        hide-details
        label="Повтор паролю"
        placeholder="********"
        type="password"
        @blur="resetV$.resetData.passwordRepeat.$touch()"></b-input>
      <b-input
        v-model="resetData.code"
        v-mask:[smsCode]
        :error-messages="getErrorMessages(resetV$.resetData.code)"
        :submit="submitResetPassword"
        class="mb-4"
        hide-details
        label="Код із СМС"
        placeholder="Введіть код"
        @blur="resetV$.resetData.code.$touch()"></b-input>
    </div>
    <v-btn
      :loading="
        $loading.isLoading(['resetPasswordSendSms', 'confirmResetPassword'])
      "
      :style="{ width: isSendSms ? '12rem' : undefined }"
      class="block w-100 btn"
      size="large"
      type="submit">
      <span>{{ isSendSms ? 'Змінити' : 'Відправити СМС' }}</span>
    </v-btn>
  </b-form>
</template>

<script setup lang="ts">
import {
  BForm,
  BInput,
  BInputPassword,
  BInputPhone,
  BLabel,
} from 'best-modules/components'
import { getErrorMessages } from '@/utils/helpers'
import { smsCode } from '@/utils/masks'
import { initAuth } from './auth'

defineOptions({
  name: 'ForgotPasswordPage',
})

const { resetData, isSendSms, resetV$, phone, submitResetPassword } = initAuth()
</script>

<style lang="scss" scoped>
.btn {
  background: #0f6ac1;
  color: #fff;
  border-radius: 4px !important;
}

.text {
  font-size: 16px;
  font-weight: 400;
  color: #323232;
  display: block;
  margin-bottom: 12px;
}
</style>
